const UUID_PATTERN = '[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}';
const CANONICAL_RE = new RegExp(`^/api/media/(${UUID_PATTERN})/([a-zA-Z0-9._-]+)$`, 'i');
const LEGACY_RE = new RegExp(`^/uploads/clients/((${UUID_PATTERN})-[a-zA-Z0-9._-]+)$`, 'i');

export const getMediaApiPath = (reference) => {
  const value = String(reference || '').trim();
  const canonical = value.match(CANONICAL_RE);
  if (canonical) return `/media/${canonical[1]}/${canonical[2]}`;

  const legacy = value.match(LEGACY_RE);
  if (legacy) return `/media/${legacy[2]}/${legacy[1]}`;

  return '';
};
